// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class RadioButtonField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.name = this.element.dataset.HierarchicalName;
    this.options = this.determineOptions();
  }

  determineOptions() {
    const query = new DomQuery(this.element);
    return query.getDescendants((node) => { return node.tagName === "INPUT" && node.name === this.name; });
  }

  focus() {
    this.options[0].focus();
  }

  getValue() {
    let result = null;
    let index = 0;

    while (result == null && index < this.options.length) {
      if (this.options[index].checked)
        result = this.options[index].value;
      else
        index++;
    }

    return result;
  }

  addEventListener(event, handler) {
    for (const option of this.options)
      option.addEventListener(event, handler);
  }
}

interactivityRegistration.register("RadioButtonField", function (element) { return new RadioButtonField(element); });
